/* eslint-disable no-mixed-spaces-and-tabs */
import * as React from "react";
import Modal, { ModalFooter, Prompt } from "@ingka/modal";
import Button from "@ingka/button";

interface InactivityModalProps {
	secondsToDisplay: number;
	minutesToDisplay: number;
	showInactivityModal: boolean;
	setShowInactivityModal: (val: boolean) => void;
}

const Layout: React.FC<InactivityModalProps> = ({
	secondsToDisplay,
	minutesToDisplay,
	showInactivityModal,
	setShowInactivityModal,
}) => {
	const timeDisplay =
		minutesToDisplay > 0
			? `${minutesToDisplay} minute${minutesToDisplay > 1 ? "s" : ""} and ${secondsToDisplay} second${
					secondsToDisplay !== 1 ? "s" : ""
			  }`
			: `${secondsToDisplay} second${secondsToDisplay !== 1 ? "s" : ""}`;

	return (
		<Modal visible={showInactivityModal} escapable={true} handleCloseBtn={() => setShowInactivityModal(false)}>
			<Prompt
				title="Session Timeout Warning"
				titleId="sessionExpWarningModalTitleId"
				footer={
					<ModalFooter>
						<Button text="Continue Session" type="emphasised" onClick={() => setShowInactivityModal(false)} />
					</ModalFooter>
				}
				header={null}
			>
				<p>
					Your session will expire in <strong>{timeDisplay}</strong> due to inactivity.
					<br></br>
					Click "Continue Session" to extend your session, or you will be automatically logged out.
				</p>
			</Prompt>
		</Modal>
	);
};

export default Layout;
